import { fetchAPI } from '@/shared/lib/api/client';

import type { ActivityItem } from '../model/types';

export const activityApi = {
  async getActivity(limit: number, offset: number): Promise<ActivityItem[]> {
    const { data } = await fetchAPI.get<ActivityItem[]>('/user/me/activity', {
      params: { limit, offset },
    });
    return data;
  },
};
